export const isReviewPhase = (state) =>
  state.reviewReady || (state.docusealFormSubmitted && !state.reviewFallback)
